import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import * as selectors from '../../../store/selector/timesheetSelector';
import * as actions from '../../../store/action/timesheetAction';
import { makeSelectTenantBasic, makeSelectTenantOpenHoursSuccess } from '../../../store/selector/tenantSelector';
import PropTypes from 'prop-types';
import "@ui5/webcomponents/dist/Icon";
import "@ui5/webcomponents-icons/dist/Assets";
import BootstrapFormControl from 'react-bootstrap/cjs/FormControl';
import Table from '../../layout/form/Table';
import SelectField from '../../layout/form/SelectField';
import ButtonGroup from '../../layout/form/ButtonGroup';
import Modal from '../../layout/form/Modal';
import Loader from '../../layout/form/Loader';
import ErrorModal from '../../layout/form/errorModal';
import SuccessModal from '../../layout/form/successModal';
import DeleteModal from '../../layout/form/deleteModal';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DatePicker from '../../layout/form/datePicker';
import TextField from '../../layout/form/TextField';
import Pagination from '../../layout/form/Pagination';
import common, { invalidToken, refeshTokenset, setDateFormat } from '../../common';
import AddTimesheet from './AddTimesheet';
import { loadProjectActivityListByStatusRequest, loadProjectAllocationListRequest } from '../../../store/action/projectAction';
import { loadObjectStatusRequest } from '../../../store/action/action';
import { makeSelectObjectStatusList, makeSelectTenantCommon, makeSelectUOMList } from '../../../store/selector/selector';
import { makeSelectUserAccessSuccess } from '../../../store/selector/usersSelector';
import ExportModal from './ExportModal';
import { exportTimesheet, exportTimesheetById } from '../../service/timesheetService';
import { saveLoginUser } from '../../../store/action/authAction';
import { CSVLink } from 'react-csv';
import Confirm from './Confirm';
import { loadTenantBasicRequest, loadTenantBasicSuccess } from '../../../store/action/tenantAction';
import { makeSelectSummarisedProjectListSuccess } from '../../../store/selector/projectSelector';
import TimesheetApproval from './TimesheetApproval';

var prevDate = new Date();
var nextDate = new Date()
const today = new Date()
const first = today.getDate() - today.getDay() + 3
const monday = new Date(today.setDate(first))
const weekStartDate = moment(monday).format(common.dateFormat)
prevDate.setDate(1);
prevDate.setMonth(prevDate.getMonth() - 2);
nextDate.setDate(nextDate.getDate() + 2)
const dateFormat = sessionStorage.getItem("dateFormat")

const customStyles = {
    control: base => ({
        ...base,
        height: 20,
        minHeight: 32,
        marginBottom: 0,
        marginTop: -20
    })
};

class Timesheet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFilterFormOpen: false,
            isUpdate: true,
            fromDate: moment(prevDate).format(common.dateFormat),
            toDate: moment(nextDate).format(common.dateFormat),
            status: '',
            pageNumber: 1,
            pageSize: 20,
            isValidationError: false,
            isDeleteModalOpen: false,
            selectedRow: {},
            isRejectModalOpen: false,
            rejectTimesheet: '',
            notes: '',
            isExportModalOpen: false,
            weekStartDate: weekStartDate,
            weekStartDateTo: weekStartDate,
            weekStartDateFrom: weekStartDate,
            exportType: "10",
            exportTimesheetId: 0,
            csvHeaders: [],
            csvData: [],
            isConfirmModalOpen: false,
            selectedTimesheet: '',
            initial: true,
            isGetTimesheetList: true,
            isCurrentWeek: false,
            timeEntryUOM: '',
            isApprovalModalOpen: false
        }
        this.csvLinkEl = React.createRef();
    }

    static getDerivedStateFromProps(prevProps, prevState) {
        const { tenantOpenHours, tenantDetails, uomList } = prevProps;
        const { initial, fromDate, toDate } = prevState
        if (initial && tenantOpenHours && tenantOpenHours.id > 0 && tenantDetails && tenantDetails.id > 0 && uomList && uomList.length > 0) {
            const weekDay = today.getDate() - today.getDay() + tenantOpenHours.weekStartDay - 1
            const firstDate = new Date(today.setDate(weekDay))
            const weekStartDate_ = moment(firstDate).format(common.dateFormat)
            const uom = uomList.find(e => e.id === tenantDetails.timeEntryUOMId)

            const fromDate_ = new Date(fromDate)
            const toDate_ = new Date(toDate)
            const startDate = fromDate_.getDate() - fromDate_.getDay() + tenantOpenHours.weekStartDay - 1
            const endDate = toDate_.getDate() - toDate_.getDay() + tenantOpenHours.weekStartDay + 5
            const startWeekFirstDate = new Date(fromDate_.setDate(startDate))
            const endtWeekFirstDate = new Date(toDate_.setDate(endDate))
            return {
                initial: false,
                weekStartDate: weekStartDate_,
                weekStartDateTo: weekStartDate_,
                weekStartDateFrom: weekStartDate_,
                fromDate: moment(startWeekFirstDate).format(common.dateFormat),
                toDate: moment(endtWeekFirstDate).format(common.dateFormat),
                timeEntryUOM: uom?.description
            }
        }

        return null;
    }

    componentDidMount() {
        const id = sessionStorage.getItem("tenantId")
        this.props.dispatch(loadTenantBasicSuccess({}))
        this.props.dispatch(loadTenantBasicRequest(id))
        this.props.dispatch(actions.loadSelectedTimesheetSuccess(''))
        this.props.dispatch(actions.saveIsTimesheetOpenStatus(false))
        this.props.dispatch(loadProjectAllocationListRequest("50"))
        this.props.dispatch(loadProjectActivityListByStatusRequest("50"))
        this.props.dispatch(loadObjectStatusRequest(common.objectId.timesheet));
        this.props.dispatch(actions.loadTimeTypeRequest())
        this.props.dispatch(actions.loadTimesheetListLoading(true))
    }

    getTimesheetList = () => {
        const parameters = {
            pageSize: this.state.isFilterFormOpen ? 20 : this.state.pageSize,
            pageNumber: this.state.isFilterFormOpen ? 1 : this.state.pageNumber,
            status: this.state.status,
            toDate: this.state.toDate,
            fromDate: this.state.fromDate
        }
        this.props.dispatch(actions.loadTimesheetListRequest(parameters))
    }

    addTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Add new timesheet
        </Tooltip>
    );

    filterTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Filter
        </Tooltip>
    );

    csvTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Export
        </Tooltip>
    );

    refreshTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Refresh
        </Tooltip>
    );

    handleAdd = (isUpdate, data) => {
        const parms = {
            weekStartDate: data.weekStartDate,
            userId: data.userId
        }
        this.props.dispatch(actions.loadSelectedTimesheetSuccess(''))
        this.props.dispatch(actions.loadSelectedTimesheetRequest(parms))
        this.props.dispatch(actions.saveIsTimesheetOpenStatus(true))
        this.setState({
            isUpdate: isUpdate
        })
    }

    handleAddNew = (isUpdate) => {
        const userId = sessionStorage.getItem("tenantUserId")
        const parms = {
            weekStartDate: this.state.weekStartDate,
            userId: userId
        }
        this.props.dispatch(actions.loadSelectedTimesheetSuccess(''))
        this.props.dispatch(actions.loadSelectedTimesheetRequest(parms))
        this.props.dispatch(actions.saveIsTimesheetOpenStatus(true))
        this.setState({
            isUpdate: isUpdate
        })
    }

    handleClose = () => {
        this.setState({
            isUpdate: false
        })
        this.props.dispatch(actions.loadSelectedTimesheetSuccess(''))
        this.props.dispatch(actions.saveIsTimesheetOpenStatus(false))
        this.handleRejectModalClose()
        this.handleConfirmClose()
        this.getTimesheetList()
    }

    handleDeleteConfirm = (data) => {
        this.setState({ isDeleteModalOpen: true, selectedRow: data })
    }

    handleDeleteModalClose = () => {
        this.setState({ isDeleteModalOpen: false, selectedRow: {} })
    }

    handleDeleteTimesheet = () => {
        this.handleDeleteModalClose()
        this.props.dispatch(actions.sendDeleteTimesheetRequest(this.state.selectedRow.id))
    }

    handleApprovals = (data) => {
        this.props.dispatch(actions.loadTimesheetApprovalSuccess([]))
        this.props.dispatch(actions.loadTimesheetApprovalRequest(data.id))
        this.setState({
            isApprovalModalOpen: true
        })
    }

    handleApprovalsClose = () => {
        this.props.dispatch(actions.loadTimesheetApprovalSuccess([]))
        this.setState({
            isApprovalModalOpen: false
        })
    }

    handleSave = () => {
        const { selectedTimesheet } = this.state;

        const times = []
        for (let j = 0; j < selectedTimesheet.times.length; j++) {
            var details = selectedTimesheet.times[j]
            if (details.day1Details.length > 0) {
                for (let i = 0; i < details.day1Details.length; i++) {
                    const element = details.day1Details[i]
                    times.push(element)
                }
            }
        }

        const parameters = {
            weekStartDate: selectedTimesheet.weekStartDate,
            id: selectedTimesheet.id,
            timeDetails: times,
            statusId: selectedTimesheet.statusId,
            totalHours: selectedTimesheet.totalHours
        }
        if (selectedTimesheet.id > 0) {
            this.props.dispatch(actions.sendUpdateTimesheetRequest(parameters))
        } else
            this.props.dispatch(actions.sendAddNewTimesheetRequest(parameters))

    }

    handleSaveAddNew = (details, status) => {
        if (details.timesheets && details.timesheets.length > 1) {
            const item = details.timesheets[0]
            if (item && item.projectActivityId === 0) {
                this.setState({ isValidationError: true, errorMassage: 'Please select a project and add your times' })
                return
            }
        }
        const projectActivities = this.handleChangeTimesheetStatus(details.timesheets, status)
        const parameters = {
            weekStartDate: details.weekStartDate,
            id: details.id ? details.id : 0,
            statusId: status,
            totalHours: details.totalHours,
            userName: details.userName ? details.userName : null,
            projectActivities: projectActivities
        }
        this.setState({
            isConfirmModalOpen: true,
            selectedTimesheet: parameters
        })
    }

    handleSubmit = () => {
        const { selectedTimesheet } = this.state;
        const parameters = {
            id: selectedTimesheet.id,
            statusId: selectedTimesheet.statusId,
            totalHours: selectedTimesheet.totalHours,
            projectActivities: selectedTimesheet.projectActivities
        }
        this.props.dispatch(actions.sendUpdateTimesheetStatusRequest(parameters))
    }

    handleSaveStatus = (details, status) => {
        const tempItemList = details.tempTimesheetsList.filter(data => (data.operation === "D"))
        const projectActivities = this.handleChangeTimesheetStatus(details.timesheets, status)
        var newList = details.timesheets
        const lastRow = newList[newList.length - 1]
        if (lastRow && lastRow.lastRow === true) {
            newList.pop();
        }
        const times = newList.concat(tempItemList)
        const parameters = {
            weekStartDate: details.weekStartDate,
            id: details.id,
            times: times,
            statusId: status,
            totalHours: details.totalHours,
            approverNote: null,
            userName: details.userName ? details.userName : null,
            projectActivities: projectActivities
        }
        this.setState({
            isConfirmModalOpen: true,
            selectedTimesheet: parameters
        })
    }

    handleRejectTimesheet = (details, status) => {
        const tempItemList = details.tempTimesheetsList.filter(data => (data.operation === "D"))
        var newList = details.timesheets
        const lastRow = newList[newList.length - 1]
        if (lastRow && lastRow.lastRow === true) {
            newList.pop();
        }
        const times = newList.concat(tempItemList)
        const parameters = {
            weekStartDate: details.weekStartDate,
            id: details.id,
            times: times,
            statusId: status,
            totalHours: details.totalHours
        }
        this.setState({
            isRejectModalOpen: true,
            rejectTimesheet: parameters
        })
        // this.props.dispatch(actions.sendUpdateTimesheetStatusRequest(parameters))
    }

    handleReject = () => {
        const { rejectTimesheet, notes } = this.state;
        const parameters = {
            weekStartDate: rejectTimesheet.weekStartDate,
            id: rejectTimesheet.id,
            times: rejectTimesheet.times,
            statusId: rejectTimesheet.statusId,
            totalHours: rejectTimesheet.totalHours,
            approverNote: notes,
        }
        this.props.dispatch(actions.sendUpdateTimesheetStatusRequest(parameters))
    }

    handleRejectModalClose = () => {
        this.setState({
            isRejectModalOpen: false,
            rejectTimesheet: '',
            notes: ''
        })
    }

    handleChangeTimesheetStatus = (activities, status) => {
        var list = []
        if (activities.length > 0) {
            for (let i = 0; i < activities.length - 1; i++) {
                const item = activities[i]
                const newItem = {
                    id: item.projectActivityId,
                    statusId: status,
                    note: ''
                }
                list.push(newItem)
            }
        }
        return list;
    }

    getNextPage = () => {
        this.setState({
            pageNumber: this.state.pageNumber + 1
        })
    }

    getPrevPage = () => {
        this.setState({
            pageNumber: this.state.pageNumber - 1
        })
    }

    setClickedPage = (page) => {
        this.setState({
            pageNumber: page
        })
    }

    setPageSize = (size) => {
        this.setState({
            pageSize: size,
            pageNumber: 1
        })
    }

    setDateFormat = (value) => {
        const date = moment(value).format(dateFormat ? dateFormat : common.dateFormat);
        return date
    }

    setEndDateFormat = (value) => {
        const { tenantCommon } = this.props;
        const day = new Date(value)
        const weekLastDay = day.setDate(day.getDate() + 6)
        const date = moment(weekLastDay).format(tenantCommon?.dateFormat? tenantCommon.dateFormat :dateFormat ? dateFormat : common.dateFormat);
        return date
    }

    setStatusDescription = (data) => {
        const { objectStatusList } = this.props;
        const statusId = data.statusId ? data.statusId : "30"
        if (objectStatusList && objectStatusList.length && objectStatusList.length !== 0) {
            const desc = objectStatusList.find(select => select.id === statusId)
            return (desc && desc.description ? desc.description : '')
        }
    }

    handleChangeSelect = (value, id) => {
        this.setState({
            [id]: value
        })
    }

    handleDateChange = (date, id) => {
        const { tenantOpenHours } = this.props;
        if (date === null) {
            return
        }
        if (id === 'weekStartDateFrom' || id === 'weekStartDateTo') {
            const currentDate = new Date(date)
            const first = currentDate.getDate() - currentDate.getDay() + tenantOpenHours.weekStartDay - 1
            const weekMonday = new Date(currentDate.setDate(first))
            const startDate = moment(weekMonday).format(common.dateFormat)
            this.setState({
                [id]: startDate,
            })
        }
        else {
            this.setState({
                [id]: moment(date).format(common.dateFormat)
            })
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleProjectStatus = (id, rowData) => {
        const { selectedTimesheet } = this.state;
        const selectedRow = selectedTimesheet.projectActivities[rowData.index]
        selectedRow.statusId = id
        selectedTimesheet.projectActivities[rowData.index] = selectedRow
        this.setState({ selectedTimesheet })
    }

    handleNote = (e, rowData) => {
        const { selectedTimesheet } = this.state;
        const selectedRow = selectedTimesheet.projectActivities[rowData.index]
        selectedRow.note = e.target.value
        selectedTimesheet.projectActivities[rowData.index] = selectedRow
        this.setState({ selectedTimesheet })
    }

    errorModalClose = () => {
        this.setState({ isValidationError: false, errorMassage: '' })
        this.props.dispatch(actions.loadTimesheetListError(null))
    }

    successModalClose = () => {
        this.props.dispatch(actions.sendTimesheetSuccess(null))
        this.handleClose()
    }

    handleFilterForm = () => {
        this.setState({
            isFilterFormOpen: !this.state.isFilterFormOpen,
            status: this.state.status,
            toDate: this.state.toDate,
            fromDate: this.state.fromDate
        })
    }

    handleRefresh = () => {
        const { tenantOpenHours } = this.props;
        const fromDate_ = new Date(prevDate)
        const toDate_ = new Date(nextDate)
        const startDate = fromDate_.getDate() - fromDate_.getDay() + tenantOpenHours.weekStartDay - 1
        const endDate = toDate_.getDate() - toDate_.getDay() + tenantOpenHours.weekStartDay + 5
        const startWeekFirstDate = new Date(fromDate_.setDate(startDate))
        const endtWeekFirstDate = new Date(toDate_.setDate(endDate))
        this.setState({
            isFilterFormOpen: false,
            status: '',
            pageNumber: 1,
            pageSize: 20,
            fromDate: moment(startWeekFirstDate).format(common.dateFormat),
            toDate: moment(endtWeekFirstDate).format(common.dateFormat),
        })

        const parameters = {
            status: '',
            pageNumber: 1,
            pageSize: 20,
            fromDate: moment(startWeekFirstDate).format(common.dateFormat),
            toDate: moment(endtWeekFirstDate).format(common.dateFormat),
        }
        this.props.dispatch(actions.loadTimesheetListRequest(parameters))
    }

    handleExportByIdModal = (data) => {
        this.setState({
            isExportModalOpen: true,
            exportTimesheetId: data.id
        })
    }


    handleExportModal = () => {
        this.setState({
            isExportModalOpen: true
        })
    }

    handleExportModalClose = () => {
        this.setState({
            isExportModalOpen: false,
            csvHeaders: [],
            csvData: [],
            exportTimesheetId: 0
        })
    }

    handleConfirmClose = () => {
        this.setState({
            isConfirmModalOpen: false,
            selectedTimesheet: ''
        })
    }

    handleGetCSV = async () => {
        if (this.state.weekStartDateFrom === null ||
            this.state.weekStartDateTo === null) {
            this.setState({ isValidationError: true, errorMassage: 'Select Report Period' })
            return
        }
        this.props.dispatch(actions.loadTimesheetListLoading(true));
        const response = await this.getReportCSV();

        if (response && response.data && response.data.statusCode && response.data.statusCode === 200 && response.data.result.errorCode && response.data.result.errorCode === 5000) {
            const massage = 'Data not available for requested period'
            this.props.dispatch(actions.loadTimesheetListError(massage))
        }
        else if (response && response.data && response.data.statusCode && response.data.statusCode === 200) {
            // console.log(response.data.result)
            const data = response.data.result.tableData
            //   data.push({Label:'{}'})
            this.setState({
                csvData: data,
                csvHeaders: response.data.result.header
            }, () => {
                setTimeout(() => {
                    this.csvLinkEl.current.link.click();
                    this.handleExportModalClose()
                });
            });
        }
        else if (response && response.data && response.data.statusCode && response.data.statusCode === 403) {
            this.props.dispatch(saveLoginUser(false))
            invalidToken()
        }
        else {
            const massage = common.error
            this.props.dispatch(actions.loadTimesheetListError(massage))
        }
        if (response && response.data && response.data.result && response.data.result.newAccessToken) {
            refeshTokenset(response.data.result.newAccessToken)
        }
        this.props.dispatch(actions.loadTimesheetListLoading(false));
    }

    handleSelect = (value, id) => {
        this.setState({
            [id]: value
        })
    }

    getReportCSV = () => {
        const parameters = {
            startDate: moment(this.state.weekStartDateFrom).format(common.dateFormat),
            endDate: moment(this.state.weekStartDateTo).format(common.dateFormat),
            type: this.state.exportType,
            id: this.state.exportTimesheetId
        }
        if (this.state.exportTimesheetId > 0) {
            return exportTimesheetById(parameters).then(
                (response) => response,
                (err) => err
            )
        } else {
            return exportTimesheet(parameters).then(
                (response) => response,
                (err) => err
            )
        }
    }

    handleFilter = () => {
        this.getTimesheetList()
        this.handleFilterForm()
    }

    componentDidUpdate(prevProps, prevState) {
        const { tenantOpenHours } = this.props;
        if (this.state.isGetTimesheetList && tenantOpenHours && tenantOpenHours.id > 0) {
            this.getTimesheetList()
            this.setState({
                isGetTimesheetList: false
            })
        }
        if (this.props.timesheetSuccess !== null) {
            setTimeout(
                () => this.successModalClose(),
                1000
            );
        }
        if ((this.state.pageNumber !== prevState.pageNumber) || (this.state.pageSize !== prevState.pageSize)) {
            this.getTimesheetList()
        }
    }

    render() {

        const {
            isTimesheetModalOpen,
            timesheetList,
            isTimesheetListLoading,
            timesheetListError,
            timesheetSuccess,
            objectStatusList,
            userAccess,
            tenantOpenHours,
            summarisedProjectList,
            timesheetApprovals,
            tenantCommon
        } = this.props;

        const {
            isFilterFormOpen,
            isDeleteModalOpen,
            selectedRow,
            isRejectModalOpen,
            isExportModalOpen,
            weekStartDateTo,
            weekStartDateFrom,
            exportType,
            exportTimesheetId,
            csvHeaders,
            csvData,
            isConfirmModalOpen,
            selectedTimesheet,
            timeEntryUOM,
            isApprovalModalOpen
        } = this.state;

        // const columns = [{
        //     Header: 'Start Date',
        //     accessor: 'weekStartDate',
        //     Cell: ((row) => (
        //         <div >
        //             {row.row.original.weekStartDate === '1/1/0001' ? '' : this.setDateFormat(row.row.original.weekStartDate)}
        //         </div>
        //     )),
        //     width: "15%",
        // }, {
        //     Header: 'End Date',
        //     accessor: 'endDate',
        //     Cell: ((row) => (
        //         <div >
        //             {row.row.original.weekStartDate === '1/1/0001' ? '' : this.setEndDateFormat(row.row.original.weekStartDate)}
        //         </div>
        //     )),
        //     width: "15%",
        // }, {
        //     Header: 'UOM',
        //     accessor: 'uom',
        //     Cell: ((row) => (
        //         <div >
        //             {timeEntryUOM}
        //         </div>
        //     )),
        //     width: "5%",
        // }, {
        //     Header: () => (<div style={{ textAlign: "right" }}>Time</div>),
        //     accessor: 'totalTime',
        //     width: "10%",
        //     Cell: ((row) => (
        //         <div style={{
        //             textAlign: "right"
        //         }}>
        //             {row.row.original.totalTime ? parseFloat(row.row.original.totalTime).toFixed(2) : "0.00"}
        //         </div>
        //     ))
        // // }, {
        // //     Header: 'Notes',
        // //     accessor: 'approverNote',
        // }, {
        //     Header: 'Status',
        //     accessor: 'statusId',
        //     width: "8%",
        //     Cell: ((row) => (
        //         <div style={{ padding: '2px' }}>
        //             {row.row.original.statusId === "10" ?
        //                 <div style={{ backgroundColor: '#ebd936', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
        //                 row.row.original.statusId === "60" ?
        //                     <div style={{ backgroundColor: '#36eb69', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
        //                     row.row.original.statusId === "30" ?
        //                         <div style={{ backgroundColor: '#6da4e4', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
        //                         row.row.original.statusId === "40" ?
        //                             <div style={{ backgroundColor: '#eb7f36', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
        //                             row.row.original.statusId === "20" ?
        //                                 <div style={{ backgroundColor: '#a2eb36', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
        //                                 <div style={{ backgroundColor: '#ff6384', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div>
        //             }
        //         </div>
        //     )),
        // }, {
        //     Header: 'Action',
        //     width: "12%",
        //     Cell: ((row) => (
        //         <div>
        //             {/* <Button */}
        //             {<span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                 <span onClick={() => this.handleAdd(true, row.row.original)}><ui5-icon class="samples-margin" name="edit" id="table-icon"></ui5-icon></span>
        //                 <span onClick={(userAccess && userAccess.deleteTimesheet && row.row.original.statusId === "10") ? () => this.handleDeleteConfirm(row.row.original) : ''}><ui5-icon class="samples-margin" name="delete" id={userAccess && userAccess.deleteTimesheet && row.row.original.statusId === "10" ? "table-icon" : "table-icon-disabled"}></ui5-icon></span>
        //                 {/* <ui5-icon class="samples-margin" name="menu" id="table-icon"></ui5-icon>  */}
        //             </span>}
        //             {/* /> */}
        //         </div>
        //     )),
        //     accessor: 'action'
        // }]

        const columns = [
            {
                Header: 'Resource',
                accessor: 'userName',
                // width: "18%",
            }, {
                Header: 'Start Date',
                accessor: 'weekStartDate',
                Cell: ((row) => (
                    <div >
                        {row.row.original.weekStartDate === '1/1/0001' ? '' : setDateFormat(row.row.original.weekStartDate, tenantCommon?.dateFormat )}
                    </div>
                )),
                width: "12%",
            }, {
                Header: 'End Date',
                accessor: 'endDate',
                Cell: ((row) => (
                    <div >
                        {row.row.original.weekStartDate === '1/1/0001' ? '' : this.setEndDateFormat(row.row.original.weekStartDate)}
                    </div>
                )),
                width: "12%",
            }, {
                Header: 'UOM',
                accessor: 'uom',
                Cell: ((row) => (
                    <div >
                        {timeEntryUOM}
                    </div>
                )),
                width: "5%",
            }, {
                Header: () => (<div style={{ textAlign: "right" }}>Time</div>),
                accessor: 'totalTime',
                width: "10%",
                Cell: ((row) => (
                    <div style={{
                        textAlign: "right"
                    }}>
                        {row.row.original.totalTime ? parseFloat(row.row.original.totalTime).toFixed(2) : "0.00"}
                    </div>
                ))
                // }, {
                //     Header: 'Notes',
                //     accessor: 'approverNote',
            }, {
                Header: 'Status',
                accessor: 'statusId',
                width: "12%",
                Cell: ((row) => (
                    <div style={{ padding: '2px' }}>
                        {row.row.original.statusId === "10" ?
                            <div style={{ backgroundColor: '#ebd936', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
                            row.row.original.statusId === "60" ?
                                <div style={{ backgroundColor: '#36eb69', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
                                row.row.original.statusId === "30" ?
                                    <div style={{ backgroundColor: '#6da4e4', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
                                    row.row.original.statusId === "40" ?
                                        <div style={{ backgroundColor: '#eb7f36', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
                                        row.row.original.statusId === "20" ?
                                            <div style={{ backgroundColor: '#a2eb36', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div> :
                                            <div style={{ backgroundColor: '#ff6384', color: 'white', borderRadius: '20px', padding: '2px', paddingLeft: '10px', paddingRight: '10px' }}>{this.setStatusDescription(row.row.original)}</div>
                        }
                    </div>
                )),
            }, {
                Header: 'Action',
                width: "8%",
                Cell: ((row) => (
                    <div>
                        {/* <Button */}
                        {<span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <span onClick={() => this.handleAdd(true, row.row.original)}><ui5-icon class="samples-margin" name="edit" id="table-icon"></ui5-icon></span>
                            <span className="dropdown" style={{ float: 'left' }}>
                                <ui5-icon class="samples-margin" name="menu" id="table-icon"></ui5-icon>
                                <div className="dropdown-content">
                                    {userAccess && userAccess.deleteTimesheet && row.row.original.statusId === "10" ? <li onClick={() => this.handleDeleteConfirm(row.row.original)}><ui5-icon class="samples-margin" name="delete" id="action-icon"></ui5-icon> Delete</li> : ''}
                                    <li onClick={() => this.handleApprovals(row.row.original)}><ui5-icon class="samples-margin" name="journey-change" id="action-icon"></ui5-icon> Journey</li>
                                    <li onClick={userAccess && userAccess.downloadTimesheet ? () => this.handleExportByIdModal(row.row.original) : ''}><ui5-icon class="samples-margin" name="download-from-cloud" id="action-icon"></ui5-icon> Export</li>
                                </div>
                            </span>
                        </span>}
                        {/* /> */}
                    </div>
                )),
                accessor: 'action'
            }
        ]

        const projectActivityColumns = [{
            Header: 'Project',
            accessor: 'id',
            Cell: (rowData) => (
                <div>
                    <SelectField
                        controlId="id"
                        options={summarisedProjectList && summarisedProjectList.result && summarisedProjectList.result.length ? summarisedProjectList.result : []}
                        style={customStyles}
                        selectedValue={rowData.cell.row.original.id}
                        disabled
                    />
                </div>
            ),
            width: "30%",
        }, {
            Header: 'Status',
            accessor: 'status',
            Cell: (rowData) => (
                <div>
                    <SelectField
                        controlId="id"
                        options={common.timesheetStatus}
                        style={customStyles}
                        selectedValue={rowData.cell.row.original.statusId}
                        onChange={(e) => this.handleProjectStatus(e, rowData.cell.row)}
                    />
                </div>
            ),
            width: "15%",
        }, {
            Header: 'Note',
            accessor: 'note',
            Cell: (rowData) => (
                <div>
                    <BootstrapFormControl
                        controlId={rowData.cell.row.original.note}
                        type="text"
                        defaultValue={rowData.cell.row.original.note}
                        size="sm"
                        onBlur={(e) => this.handleNote(e, rowData.cell.row)}
                    />
                </div>
            ),
        }]

        return (
            <div>
                {isTimesheetListLoading ?
                    <Loader show={isTimesheetListLoading} /> : ''}

                {(this.state.isValidationError || timesheetListError !== null) &&
                    <ErrorModal
                        show={true}
                        massage={this.state.errorMassage ? this.state.errorMassage : timesheetListError}
                        handleClose={this.errorModalClose}
                    />}
                {timesheetSuccess !== null &&
                    <SuccessModal
                        show={true}
                        massage={timesheetSuccess}
                        handleClose={this.successModalClose}
                    />}
                {isDeleteModalOpen &&
                    <DeleteModal
                        show={isDeleteModalOpen}
                        handleDeleteModalClose={this.handleDeleteModalClose}
                        handleDelete={this.handleDeleteTimesheet}
                        title={selectedRow.id}
                    />}
                {isRejectModalOpen &&
                    <Modal
                        show={isRejectModalOpen}
                        onHide={this.handleRejectModalClose}
                        title="Reason for Rejection"
                        width='40%'
                        body={
                            <div>
                                {/* <h5>Basic Data</h5> */}
                                <form style={{ marginTop: "5px" }}>
                                    <div className="col-sm">
                                        <TextField
                                            text="Notes"
                                            controlId="notes"
                                            defaultValue={this.state.notes}
                                            onBlur={this.handleChange}
                                            as="textarea"
                                            // row={50}
                                            style={{ height: 200 }}
                                        />
                                    </div>
                                </form>
                            </div>
                        }
                        footer={
                            <div>
                                <ButtonGroup
                                    primaryBtnClick={this.handleRejectModalClose}
                                    primaryBtnVariant="outline-primary"
                                    // primaryBtnText='Cancel'
                                    // primaryBtnIcon='decline'
                                    primaryBtnText='Go Back'
                                    primaryBtnIcon='undo'
                                    secondaryBtnClick={() => this.handleReject(this.state)}
                                    secondaryBtnText='Save'
                                    secondaryBtnVariant="outline-primary"
                                    secondaryBtnIcon='save'
                                />
                            </div>
                        }
                    />
                }
                {isConfirmModalOpen &&
                    <Confirm
                        show={isConfirmModalOpen}
                        handleModalClose={this.handleConfirmClose}
                        width={selectedTimesheet.statusId !== "30"}
                        title={
                            <div>
                                {selectedTimesheet.statusId === "10" ? "If you want to save as a draft ?" :
                                    selectedTimesheet.statusId === "30" ? "If you want to submit ?" :
                                        selectedTimesheet.statusId === "20" ? "Are you sure you approve of this ?" : ''} </div>
                        }
                        content={
                            <div>
                                {selectedTimesheet.userName ? <div>Employee: {selectedTimesheet.userName}</div> : ''}
                                <div>Weekstart: {selectedTimesheet.weekStartDate}</div>
                                <div>Total worked time: {selectedTimesheet.totalHours}</div>
                                {selectedTimesheet.statusId === "30" ? null :
                                    <div className="table-content">
                                        <Table
                                            columns={projectActivityColumns}
                                            data={selectedTimesheet && selectedTimesheet.projectActivities.length ? selectedTimesheet.projectActivities : []}
                                        />
                                    </div>}
                            </div>
                        }
                        handleConfirm={() => this.handleSubmit()
                            // selectedTimesheet.statusId === "10" ? () => this.handleSave() : 
                            // selectedTimesheet.statusId === "30" ? () => this.handleSave() :
                            // selectedTimesheet.statusId === "20" ? () => this.handleApprove() :   ''
                        }
                    />
                }
                {isExportModalOpen ?
                    <ExportModal
                        isExportModalOpen={isExportModalOpen}
                        handleModalClose={this.handleExportModalClose}
                        weekStartDateTo={weekStartDateTo}
                        weekStartDateFrom={weekStartDateFrom}
                        handleDateChange={this.handleDateChange}
                        handleGetCSV={this.handleGetCSV}
                        handleSelect={this.handleSelect}
                        exportType={exportType}
                        exportTimesheetId={exportTimesheetId}
                    />
                    : ''
                }
                <CSVLink
                    headers={csvHeaders}
                    filename={weekStartDateFrom}
                    data={csvData}
                    ref={this.csvLinkEl}
                    enclosingCharacter={``}
                />
                {
                    isApprovalModalOpen ?
                        <TimesheetApproval
                            isApprovalModalOpen={isApprovalModalOpen}
                            timesheetApprovals={timesheetApprovals}
                            handleModalClose={this.handleApprovalsClose}
                            setStatusDescription={this.setStatusDescription}
                            setDateFormat={setDateFormat}
                            tenantCommon={tenantCommon}
                        />
                        : ''
                }
                {isTimesheetModalOpen ?
                    <div>
                        <AddTimesheet
                            handleClose={this.handleClose}
                            handleSaveAddNew={this.handleSaveAddNew}
                            handleSaveStatus={this.handleSaveStatus}
                            handleRejectTimesheet={this.handleRejectTimesheet}
                            isUpdate={this.state.isUpdate}
                            modifyTimesheet={userAccess.modifyTimesheet}
                            createTimesheet={userAccess.createTimesheet}
                            approveTimesheet={userAccess.approveTimesheet}
                            weekStartDate={this.state.weekStartDate}
                            tenantOpenHours={tenantOpenHours}
                        />
                    </div> :
                    <div>
                        <div className="content-header">
                            <div className="header-pages">
                                <ui5-icon class="samples-margin" name="fob-watch" id="header-icon"></ui5-icon><span>TIMESHEET</span>
                            </div>
                        </div>
                        <div className="content-body">
                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                                <div style={{ display: 'flex' }}>
                                    <div>
                                        <h5 style={{ marginLeft: '5px' }}>Timesheet List</h5>
                                    </div>
                                </div>
                                <div className="header-btn">
                                    <div style={{ display: 'flex' }}>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.refreshTooltip}
                                        >
                                            <span className="header-icon" onClick={() => this.handleRefresh()}>
                                                <ui5-icon class="samples-margin" name="refresh" id="header-icon"></ui5-icon>
                                            </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.addTooltip}
                                        >
                                            <span className={userAccess && userAccess.createTimesheet ? "header-icon" : "header-icon-disabled"} onClick={userAccess && userAccess.createTimesheet ? () => this.handleAddNew(false) : ''}>
                                                <ui5-icon class="samples-margin" name="add" id="header-icon"></ui5-icon>
                                            </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.filterTooltip}
                                        >
                                            <span className="header-icon" onClick={() => this.handleFilterForm()}>
                                                <ui5-icon class="samples-margin" name="filter" id="header-icon"></ui5-icon>
                                            </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.csvTooltip}
                                        >
                                            <span className={userAccess && userAccess.downloadTimesheet ? "header-icon" : "header-icon-disabled"} onClick={userAccess && userAccess.downloadTimesheet ? () => this.handleExportModal() : ''}>
                                                <ui5-icon class="samples-margin" name="download-from-cloud" id="header-icon"></ui5-icon>
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                            {isFilterFormOpen &&
                                <div className="filter-form">
                                    <div className="filter-header">
                                        <h5>Filter Form</h5>
                                        <div className="btn-close" onClick={this.handleRefresh} >
                                            <ui5-icon class="samples-margin" name="decline" id="btn-icon"></ui5-icon>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm">
                                            <SelectField
                                                text="Status"
                                                controlId="status"
                                                options={objectStatusList}
                                                onChange={(e) => this.handleChangeSelect(e, "status")}
                                                selectedValue={this.state.status}
                                                isClearable
                                            />
                                        </div>
                                        <div className="col-sm">
                                            <DatePicker
                                                text="From date"
                                                controlId="fromDate"
                                                onChange={(e) => this.handleDateChange(e, "fromDate")}
                                                value={this.state.fromDate === null ? '' : new Date(this.state.fromDate)}
                                            />
                                        </div>
                                        <div className="col-sm">
                                            <DatePicker
                                                text="To date"
                                                controlId="toDate"
                                                onChange={(e) => this.handleDateChange(e, "toDate")}
                                                value={this.state.fromDate === null ? '' : new Date(this.state.toDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="filter-btns">
                                        <ButtonGroup
                                            primaryBtnClick={this.handleFilter}
                                            primaryBtnIcon='search'
                                            primaryBtnText='Search'
                                            primaryBtnVariant="outline-primary"
                                            secondaryBtnClick={this.handleRefresh}
                                            secondaryBtnIcon='clear-filter'
                                            secondaryBtnText='Clear'
                                            secondaryBtnVariant="outline-primary"
                                        />
                                    </div>
                                </div>}
                            <div className="table-content">
                                <Table
                                    columns={columns}
                                    data={timesheetList.result && timesheetList.result.length ? timesheetList.result : []}
                                />
                            </div>
                            <Pagination
                                currentPage={timesheetList.page ? timesheetList.page : this.state.pageNumber}
                                getNextPage={this.getNextPage}
                                getPrevPage={this.getPrevPage}
                                totalPage={timesheetList.totalPages}
                                setClickedPage={this.setClickedPage}
                                currentPageSize={this.state.pageSize}
                                setPageSize={this.setPageSize}
                            />
                        </div>
                    </div>}
            </div>
        )
    }
}

Timesheet.propTypes = {
    isTimesheetModalOpen: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
    isTimesheetModalOpen: selectors.makeSelectTimesheetOpen(),
    timesheetList: selectors.makeSelectTimesheetList(),
    isTimesheetListLoading: selectors.makeSelectTimesheetListLoading(),
    timesheetListError: selectors.makeSelectTimesheetListError(),
    timesheetSuccess: selectors.makeSelectTimesheetSuccess(),
    objectStatusList: makeSelectObjectStatusList(),
    userAccess: makeSelectUserAccessSuccess(),
    tenantOpenHours: makeSelectTenantOpenHoursSuccess(),
    tenantDetails: makeSelectTenantBasic(),
    uomList: makeSelectUOMList(),
    summarisedProjectList: makeSelectSummarisedProjectListSuccess(),
    timesheetApprovals: selectors.makeTimesheetApprovalList(),
    tenantCommon: makeSelectTenantCommon()
});

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);


export default (compose(withConnect)(Timesheet));